import styled from 'styled-components';

export const ModalSelectorContent = styled.div``;
